import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { LuX, LuBookOpen, LuListChecks, LuTrophy } from 'react-icons/lu';
import { useTeamContext } from '../../context/TeamContext';
import PlanAwareLink from '../billing/PlanAwareLink';
import PlanTierLabel from '../billing/PlanTierLabel';
import { FEATURE } from '../../config/planFeatures';
import { useUserPlan } from '../../hooks/useUserPlan';

const DISMISS_PREFIX = 'qnaread_team_member_guide_';

export default function TeamMemberGuideBanner() {
  const { orgId } = useParams();
  const { activeOrg } = useTeamContext();
  const storageKey = orgId ? `${DISMISS_PREFIX}${orgId}` : null;
  const [dismissed, setDismissed] = useState(() =>
    storageKey ? localStorage.getItem(storageKey) === '1' : true
  );
  const { canUseFeature } = useUserPlan();
  const leaderboardLocked = !canUseFeature(FEATURE.TEAM_LEADERBOARD_ANALYTICS);

  if (!orgId || dismissed || !activeOrg) return null;

  const role = (activeOrg.role || '').toUpperCase();
  const isManager = role === 'OWNER' || role === 'ADMIN' || role === 'MANAGER';

  const dismiss = () => {
    if (storageKey) localStorage.setItem(storageKey, '1');
    setDismissed(true);
  };

  const base = `/teams/${orgId}`;

  return (
    <aside className="teams-guide-banner" role="region" aria-label="Team workspace guide">
      <button type="button" className="teams-guide-dismiss" onClick={dismiss} aria-label="Dismiss guide">
        <LuX aria-hidden />
      </button>
      {isManager ? (
        <>
          <p className="teams-guide-title">Lead your team&apos;s learning</p>
          <ul className="teams-guide-list">
            <li><Link to={`${base}/groups`}>Create groups</Link> and add members</li>
            <li><Link to={`${base}/assignments`}>New assignment</Link> — assignees get a request to accept</li>
            <li><Link to={`${base}/challenges`}>New challenge</Link> — members opt in from Requests</li>
          </ul>
        </>
      ) : (
        <>
          <p className="teams-guide-title">Welcome to {activeOrg.displayName || activeOrg.name}</p>
          <ul className="teams-guide-list">
            <li><LuBookOpen aria-hidden /> In <Link to="/library">Library</Link>, mark questions <strong>read</strong> — that updates your assignment progress.</li>
            <li><LuListChecks aria-hidden /> Accept invites on <Link to={`${base}/requests`}>Requests</Link>, then track progress under Assignments.</li>
            <li>
              <LuTrophy aria-hidden /> Compete on the{' '}
              <PlanAwareLink to={`${base}/leaderboard`}>Leaderboard</PlanAwareLink>
              {leaderboardLocked && <PlanTierLabel tier="Team" />}
              ; personal XP still counts on Progress.
            </li>
          </ul>
        </>
      )}
    </aside>
  );
}
